var map = {
	"./bank-transfer.svg": 830,
	"./betnearn-ico.svg": 831,
	"./birthday-bonus-ico.svg": 832,
	"./birthday.svg": 833,
	"./bonus-code-ico.svg": 834,
	"./bonus-ico.svg": 835,
	"./bonus-received-ico.svg": 836,
	"./bonus.svg": 837,
	"./business-account-upgrade-ico.svg": 838,
	"./check-in-daily-ico.svg": 839,
	"./checked.svg": 840,
	"./cloud-pointer.svg": 841,
	"./coin.svg": 842,
	"./crypto.svg": 843,
	"./daily-bonus-ico.svg": 844,
	"./daily-limit.svg": 845,
	"./deposit-delay-bonus-ico.svg": 846,
	"./e-wallet.svg": 847,
	"./earn-x33-coin-ico.svg": 848,
	"./email.svg": 849,
	"./facebook.svg": 850,
	"./feedback.svg": 851,
	"./first-bet-ico.svg": 852,
	"./games-rebate-ico.svg": 853,
	"./info.svg": 854,
	"./instagram.svg": 855,
	"./instant-rebate.svg": 856,
	"./live-casino-rebate-ico.svg": 857,
	"./lucky-spin-ico.svg": 858,
	"./messenger.svg": 859,
	"./mobile-app-deposit-ico.svg": 860,
	"./monthly-cash.svg": 861,
	"./msg-activity.svg": 862,
	"./msg-ann.svg": 863,
	"./msg-notice.svg": 864,
	"./new-icon.svg": 865,
	"./people-ico.svg": 866,
	"./quick-pay.svg": 867,
	"./rescue-bonus-ico.svg": 868,
	"./rescue-lc-ico.svg": 869,
	"./rescue-slots-ico.svg": 870,
	"./return.svg": 871,
	"./sc-bc-active-ico.svg": 872,
	"./sc-bc-ico.svg": 873,
	"./sc-bi-active-ico.svg": 874,
	"./sc-bi-ico.svg": 875,
	"./sc-mail-active-ico.svg": 876,
	"./sc-mail-ico.svg": 877,
	"./sc-mp-active-ico.svg": 878,
	"./sc-mp-ico.svg": 879,
	"./sc-pin-active-ico.svg": 880,
	"./sc-pin-ico.svg": 881,
	"./slots-rebate-ico.svg": 882,
	"./sms.svg": 883,
	"./sports-rebate-ico.svg": 884,
	"./telegram.svg": 885,
	"./twitter.svg": 886,
	"./vip-up-level-ico.svg": 887,
	"./vip-weekly-bonus.svg": 888,
	"./wallet-balance-interest-ico.svg": 889,
	"./wallet-ico.svg": 890,
	"./weekly-tournament-ico.svg": 891,
	"./welcome-bonus-188-ico.svg": 892,
	"./welcome-bonus-ico.svg": 893,
	"./whatsapp-original.svg": 894,
	"./whatsapp.svg": 895,
	"./withdrawal-delay-bonus-ico.svg": 896,
	"./withdrawal.svg": 897,
	"./x33-coin.svg": 898
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1930;